<template>
  <div>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              modalWidth="80%"
              ref="master"
              :parentData="parentData"
              :actions="false"
    >
     <span slot="estadoRenderer" slot-scope="{text}">
       <a-icon v-bind="fillIcon(text)" />
     </span>
    </g-master>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
    },
    props: ['id_competitor', 'id_training'],
    data () {
      return {
        master: {
          endpoint: 'asistencia_evaluacion',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            actions: false,
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: 'Tema', dataIndex: 'theme', sorter: true},
              {title: 'Calificación', dataIndex: 'qualification', sorter: true},
              {
                title: 'Asistencia',
                dataIndex: 'assistance',
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              }
            ]
          }
        }
      }
    },
    methods: {
      fillIcon (text) {
        let propertyIcon = {type: 'minus', style: { color: 'red' }}
        if (text) {
          propertyIcon = {type: 'check', style: { color: '#52c41a' }}
        }
        return propertyIcon
      },
      loadData () {
        this.$refs.master.$refs.datatable.loadData()
      }
    },
    computed: {
      parentData () {
        return {
          id_competitor: this.id_competitor,
          id_training: this.id_training
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Capacitaciones/AsistenciaYEvaluacion.vue